<template>
  <div>
    <div class="cancel-align-wrapper">
      <span class="blocks-counter">Aligning {{currentAlignCounter}} block(s)</span>
      <button v-if="hasLocks('align')" class="cancel-align" v-on:click="cancelAlign(true)"><!-- title="Cancel aligning">--><!--<i class="fa fa-times-circle-o"></i>--><i class="glyphicon glyphicon-remove-circle"></i><i class="cancel-align-caption">  Cancel all</i></button>

    </div>
    <Accordion :activeIndex.sync="activeTabIndex" class="audio-integration-accordion" v-on:tab-open="checkTabOpen">
      <AccordionTab :header="'File audio catalogue'" v-bind:key="'file-audio-catalogue'" ref="panelAudiofile" class="panel-audio-catalogue">
        <div class="file-catalogue" id="file-catalogue">
          <!-- <AlignAudioSpeed
            :audio_type="'audio_file'"
            :is_catalog_active="activeTabIndex === 0 && isActive" /> -->
          <div v-html="alignBlocksLimitMessage" class="red-message align-blocks-limit" v-if="alignBlocksLimitMessage"></div>
          <div class="block-selection-info">
            <template v-if="!blockSelection.start._id">
              0 blocks selected
            </template>
            <template v-else>
              {{alignCounter.countAudio}} Audio file block(s) in range
              <a v-on:click="goToBlock(blockSelection.start._id)">{{blockSelection.start._id_short}}</a> -
              <a v-on:click="goToBlock(blockSelection.end._id)">{{blockSelection.end._id_short}}</a>
            </template>
          </div>
          <div class="file-catalogue-buttons" v-if="allowEditing">
            <div class="" v-if="allowEditing">
              <label class="checkbox-container">
                <input type="checkbox" v-model="checkAllState"/>
                <span class="checkmark"></span>
              </label>
            </div>
            <dropdown text="" :type="audiobook.hasOwnProperty('sortDirection') == false || audiobook.sortDirection == '' ? 'default' : 'button'" ref="allAudioDropdownSort" class="all-audio-dropdown aad-sort">
                <li :class="audiobook.sortDirection == 'date_desc' ? ' aad_selected' : ' '">
                  <span v-on:click="listSort('date', 'desc')">Date imported</span>
                </li>
                <li :class="audiobook.sortDirection == 'name_asc' ? ' aad_selected' : ' '">
                  <span v-on:click="listSort('name', 'asc')">Filename</span>
                </li>
            </dropdown>
            <dropdown text="" :type="this.aad_filter == 'all' ? 'default' : 'button'" ref="allAudioDropdownFilter" class="all-audio-dropdown aad-filter">
                <li :class="this.aad_filter != 'pending' && this.aad_filter != 'aligned' && this.aad_filter != 'filename' ? ' aad_selected' : ' '">
                  <span v-on:click="filterAll()">All</span>
                </li>
                <li :class="this.aad_filter == 'pending' ? ' aad_selected' : ' '">
                  <span v-on:click="filterPending()">Pending</span>
                </li>
                <li :class="this.aad_filter == 'aligned' ? ' aad_selected' : ' '">
                  <span v-on:click="filterAligned()">Aligned</span>
                </li>
                <div style="padding: 7px 12px 7px 12px;"  :class="this.aad_filter == 'filename' ? ' aad_selected flexContainer ' : ' flexContainer '"><input style="padding: 3px" v-model="filterFilename" @input="filterFileNameInput()" placeholder="Filename" class="inputField" v-on:keyup.enter="filterFileName()"><button type="submit" @click="filterFileNameReset()">&nbsp;X&nbsp;</button></div>
            </dropdown>
            <div class="upload-audio left-divider">
              <button id="show-modal" type="button" @click="uploadAudio" class="btn btn-default btn_audio_upload btn-small" >

              </button>
            </div>
            <div class="delete-audio">
              <button class="btn btn-default btn-small"
                :disabled="selectionLength == 0"
                v-on:click="deleteAudio()" >
                <i class="fa fa-trash"></i>
                <span v-if="selectionLength > 0">({{selectionLength}})</span>
              </button>
            </div>
            <div class="align-audio left-divider">
              <button class="btn btn-primary btn-small" :disabled="startAlignDisabled" v-on:click="align(null)" v-if="!alignProcess">Align&nbsp;<span v-if="selectionLength > 0">({{selectionLength}})</span></button>
              <span v-else class="align-preloader -small"></span>
              <!--<button v-if="hasLocks('align')" class="cancel-align" v-on:click="cancelAlign(true)" title="Cancel aligning"><i class="fa fa-ban"></i></button>-->
            </div>
          </div>
          <h5 v-if="audiobook.info && (!audiobook.importFiles || audiobook.importFiles.length == 0)"><i>{{audiobook.info}}</i></h5>
          <div class="file-catalogue-files-wrapper">
            <draggable :options="{disabled : renaming}" v-model="audiobook.importFiles" class="file-catalogue-files" @end="listReorder">
              <div v-for="(audiofile, index) in audiobook.importFiles"
                v-if="(audiofile.title ? audiofile.title : audiofile.name).includes(filterFilename.trim())"
                :class="getAudiofileClass(audiofile)" >
                <template v-if="(audiofile.title ? audiofile.title : audiofile.name).includes(filterFilename.trim())">
                  <template v-if="audiofile.status == 'processing' && (audiofile.title ? audiofile.title : audiofile.name).includes(filterFilename.trim())">
                    <div class="audiofile-info">
                      <i>Processing, {{audiofile.title}}</i>
                    </div>
                  </template>
                  <template v-else>
                    <div v-if="allowEditing"
                             class="audiofile-options">
                      <label class="checkbox-container">
                        <input type="checkbox"
                        :checked="selections.indexOf(audiofile.id) !== -1"
                         v-on:click="addSelection(audiofile.id, selections.indexOf(audiofile.id) === -1)"
                         :disabled="isAudiofileAligning(audiofile.id)"/>
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div :class="['audiofile-info', {'playing': playing == audiofile.id, done: audiofile.done}]">
                      <div class="audiofile-player-controls">
                        <span class="audio-opening" v-if="audioOpening === audiofile.id"></span>
                        <!-- <i v-else class="fa fa-play-circle-o" v-on:click="audiofileClick(audiofile.id, true, $event)"></i> -->
                        <template v-else>
                          <i v-if="audiofile.preview && audiofile.preview.start" class="fa fa-play-circle-o" v-on:click="playPreview(audiofile.id, 'start', $event)"></i>
                        </template>
                        <!-- <i class="fa fa-play-circle-o red" v-on:click="play()" v-if="paused === audiofile.id"></i>
                        <i class="fa fa-pause-circle-o" v-on:click="pause()" v-if="playing === audiofile.id && paused !== audiofile.id"></i>
                        <i class="fa fa-stop-circle-o" v-on:click="stop()" v-if="playing === audiofile.id"></i> -->
                      </div>
                      <div class="audiofile-name" v-on:dblclick="renameAudiofile(audiofile.id)">
                        <span v-if="audiofile.duplicate "
                          @click="duplicateAudiofileClick(audiofile.id, audiofile.duplicate, $event)"
                          :title="(audiofile.quality ? capitalizeFirst(audiofile.quality) + ' ' : '') + (audiofile.title ? audiofile.title : audiofile.name)">
                          <img v-if="audiofile.quality"
                            :src="'/static/audio_quality/' + audiofile.quality + '-16.png'" />
                            <i>Duplicate: {{audiofile.title ? audiofile.title : audiofile.name}}</i>
                        </span>
                        <span v-if="!renaming || (renaming.id !== audiofile.id && !audiofile.duplicate)"
                              :class="['audiofile-name-edit', audiofile.id.replace(/\./g, '')]"
                              @click="audiofileClick(audiofile.id, false, $event)"
                              :title="(audiofile.quality ? capitalizeFirst(audiofile.quality) + ' ' : '') + (audiofile.title ? audiofile.title : audiofile.name)" >
                              <img v-if="audiofile.quality" :src="'/static/audio_quality/' + audiofile.quality + '-16.png'" />
                              <span class="filename">{{audiofile.title ? audiofile.title : audiofile.name}}</span>
                        </span>
                        <input id="rename-input" type="text" v-model="audiofile.title" autocomplete="off"
                             class="audiofile-name-edit"
                             @blur="renameAudiofileStop()"
                             @keyup.enter="renameAudiofileStop()"
                             @change="saveAudiobook()"

                             v-else-if="!audiofile.hasOwnProperty('duplicate') || audiofile.duplicate == false" />
                      </div>
                      <div class="audiofile-player-controls">
                        <i v-if="audiofile.preview && audiofile.preview.end" class="fa fa-play-circle-o" v-on:click="playPreview(audiofile.id, 'end')"></i>
                      </div>
                      <div class="audiofile-duration"><span>{{ parseAudioLength(audiofile) }}</span></div>
                    </div>

                  </template>
                </template>
              </div>
            </draggable>
          </div>
        </div>
        <div :class="['audio-import-errors', 'errors-' + (audiobook.importErrors ? audiobook.importErrors.length : 0)]" id="audio-import-errors">
          <div style="overflow-y: scroll; min-height: 80px; height: 100%;">
            <div>Unable to import file(s):<span class="hide-errors" v-on:click="clearErrors()">&times;</span></div>
            <div v-for="ierr in audiobook.importErrors" class="audio-import-error">
              <a :href="ierr.link">{{ierr.file}}: {{ierr.error}}</a>
            </div>
          </div>
        </div>
      </AccordionTab>
      <AccordionTab :header="'TTS audio catalogue'" v-bind:key="'tts-audio-catalogue'" ref="panelTTS">
        <ElevenLabsTTS
          :is_active="activeTabIndex === 1 && isActive"
          @alignTts="alignTts"
          @cancelAlign="cancelAlign" />
        <!-- <div class="block-selection-info">
          <template v-if="!blockSelection.start._id">
            0 blocks selected
          </template>
          <template v-else>
            {{alignCounter.countTTS}} TTS block(s) in range
            <a v-on:click="goToBlock(blockSelection.start._id)">{{blockSelection.start._id_short}}</a> -
            <a v-on:click="goToBlock(blockSelection.end._id)">{{blockSelection.end._id_short}}</a>
          </template>
        </div>
        <div class="volume-slider-margin">
          <div class="tts-volume-label">Volume:</div>
          <Slider ref="slider" v-model="pre_volume" :step="0.1" :min="0.1" :max="1.0" />
        </div>
        <table class="table table-striped table-bordered table-voices">
        <thead>
          <tr>
            <th>Block</th><th>Voice</th>
          </tr>
        </thead>
        <tbody v-if="pre_options">
          <tr>
            <td>Title</td>
            <td><select-tts-voice
              :pre_selected="currentBookMeta.voices ? currentBookMeta.voices.title : ''"
              :pre_volume="pre_volume"
              :pre_options="pre_options"
              @onSelect="onTtsSelect('title', $event)"
            ></select-tts-voice></td>
          </tr>
          <tr>
            <td>Header</td>
            <td><select-tts-voice
              :pre_selected="currentBookMeta.voices ? currentBookMeta.voices.header : ''"
              :pre_volume="pre_volume"
              :pre_options="pre_options"
              @onSelect="onTtsSelect('header', $event)"
            ></select-tts-voice></td>
          </tr>
          <tr>
            <td>Paragraph</td>
            <td><select-tts-voice
              :pre_selected="currentBookMeta.voices ? currentBookMeta.voices.paragraph : ''"
              :pre_volume="pre_volume"
              :pre_options="pre_options"
              @onSelect="onTtsSelect('paragraph', $event)"
            ></select-tts-voice></td>
          </tr>
          <tr>
            <td>Footnote</td>
            <td><select-tts-voice
              :pre_selected="currentBookMeta.voices ? currentBookMeta.voices.footnote : ''"
              :pre_volume="pre_volume"
              :pre_options="pre_options"
              @onSelect="onTtsSelect('footnote', $event)"
            ></select-tts-voice></td>
          </tr>
        </tbody>
        </table>
        <div class="clearfix align-process-start">
          <button class="btn btn-default pull-right" :disabled="!enableTtsAlignment" v-on:click="alignTts()" v-if="!alignProcess">Convert text to speech &amp; Align with text</button>
          <span v-else class="align-preloader -big"></span>
          <button v-if="hasLocks('align')" class="cancel-align pull-left" v-on:click="cancelAlign()" title="Cancel aligning"><i class="fa fa-ban"></i></button>
        </div> -->
      </AccordionTab>
      <AccordionTab :header="'Export & Replace audio'" v-bind:key="'export-replace-audio'">
        <ReplaceAudio/>
      </AccordionTab>
    </Accordion>
    <div id="player"></div>
  </div>
</template>
<script>
  import {/*accordion, panel, */dropdown} from 'vue-strap'
  import Accordion from 'primevue/accordion';
  import AccordionTab from 'primevue/accordiontab';
  import task_controls from '../../mixins/task_controls.js'
  import api_config from '../../mixins/api_config.js'
  import Vue from 'vue'
  import access from '../../mixins/access.js';
  import {mapGetters, mapActions} from 'vuex';
  import Slider from 'primevue/slider';
  import ReplaceAudio from './details/ReplaceAudio.vue';
  import AudioImport from '../audio/AudioImport';
  import ElevenLabsTTS from './details/ElevenLabsTTS.vue';
  import AlignTTSVoice from '../generic/AlignTTSVoice.vue';
  import UnsavedChangesPopup from '../generic/UnsavedChangesPopup.vue';
  //import AlignAudioSpeed from './details/AlignAudioSpeed.vue';
  var WaveformPlaylist = require('waveform-playlist');
  import draggable from 'vuedraggable';
  import superlogin from 'superlogin-client';
  import PouchDB from 'pouchdb';
  import Split from 'split.js';
  import _ from 'lodash';
  import v_modal from 'vue-js-modal';
  Vue.use(v_modal, {dialog: true});
  //var d3 = require('d3')
  export default {
    name: 'BookAudioIntegration',
    computed: {

    },
    components: {
//       accordion,
//       panel,
      Accordion,
      AccordionTab,
      dropdown,
      Slider,
      draggable,
      ReplaceAudio,
      ElevenLabsTTS,
      //AlignAudioSpeed
    },
    props: {
      'isActive': Boolean
    },
    data() {
      return {
        renaming: false,
        selections: [],
        deleting: false,
        onDeleteMessage: false,
        player: false,
        playing: false,
        paused: false,
        draggableList: false,
        alignmentProcess: false,
        pre_options: false,
        pre_volume: 1.0,
        aligningBlocks: [],
        positions_tmp: {},
        alignProcess: false,
        audioOpening: false,
        activeTabIndex: 0,
        audio_element: false,
        aad_sort: '',
        aad_filter: 'all',
        filterFilename: '',
        highlightDuplicateId: '',
        split : false,
        audioEditorIsOpeed : false,
        audioSelectionTimers: {},
        highlightedAudiofiles: []
      }
    },
    mixins: [task_controls, api_config, access],
    mounted() {
      /*let ac = new (window.AudioContext || window.webkitAudioContext);
      this.player = WaveformPlaylist.init({
        ac: ac,
        samplesPerPixel: 0,
        waveHeight: 0,
        container: document.getElementById('player'),
        state: 'select',
        zoomLevels: [0],
        timescale: false,
        linkEndpoints: false
      });*/

      this.$root.$on('from-audioeditor:lock', function(blockId, audiofileId) {
        this.audioEditorIsOpeed = true;

        // var initSplitDebounce = _.debounce(function () {
        //   self.splitRecalc(true,false)
        // }, 1000);
        // initSplitDebounce();

      })
      var self = this;

      this.$root.$on('from-audioeditor:close', (blockId, audiofileId) => {
        if (audiofileId && this.playing === audiofileId) {
          this.playing = false;
        }

        Vue.nextTick(() => {
          this.splitRecalc(true)
        });

      })
      this.$root.$on('from-audioeditor:save-positions', function(id, selections) {
        if (self.audiobook && self.audiobook.importFiles) {
          let record = self.audiobook.importFiles.find(_f => {
            return _f.id == id;
          });
          if (record) {
            record.positions = selections;
            self.saveAudiobook();
          }
        }
      });
      this.$root.$on('from-audioeditor:align', function(id, selections = null) {

        if (self.audiobook && self.audiobook.importFiles) {
          let record = self.audiobook.importFiles.find(_f => {
            return _f.id == id;
          });
          if (record) {
            if (selections) {
              record.positions = selections;
              self.saveAudiobook()
                .then(() => {
                  self.align(id);
                })
                .catch(err => console.log(err));
            } else {
              self.align(id);
            }
          }
        }
      });
      this.$root.$on('from-audioeditor:discard', function() {
        if (self.audiobook && self.audiobook.importFiles) {
          let record = self.audiobook.importFiles.find(f => {
            return f.id == self.playing;
          })
          if (record) {
            self.$root.$emit('for-audioeditor:load-and-play', process.env.ILM_API + self.audiobook.importUrl + record.id, '', null, false, record)
          }
        }
      });
      this.$root.$on('from-audioeditor:content-loaded', (id) => {
        this.splitRecalc(true,false)
      });

      this.$root.$on('from-audioeditor:audio-loaded', (id) => {
        // var initSplitDebounce = _.debounce(function () {
        //   self.splitRecalc(true,false)
        // }, 1000);
        // initSplitDebounce();
        this.audioOpening = false;
        if (self.audiobook && self.audiobook.importFiles) {
          let record = this.audiobook.importFiles.find(f => f.id === id);
          if (record) {
            this.playing = id;
          }
        }
      });
      this.$root.$on('from-audioeditor:selection-change', (id, start, end) => {
        if (this.playing) {
          //console.log('FOR ', af)
          if (typeof start !== 'undefined' && typeof end !== 'undefined') {
            this.positions_tmp[this.playing] = {start: start, end: end};
            if (self.audiobook && self.audiobook.importFiles) {
              let record = this.audiobook.importFiles.find(f => f.id == this.playing);
              if (record) {
                record.positions = {start: start, end: end};
                this.$forceUpdate();
              } else {

              }
            }
          } else {
            delete this.positions_tmp[this.playing];

          }
        }
      });
      this.$root.$on('book-reimported', () => {
        this.positions_tmp = {};
      });
      this.$root.$on('from-audioeditor:close-cancelled', () => {
        this.audioOpening = false;
      });

      this._setCatalogueSize();
      window.addEventListener('resize', this.splitRecalc, true);
      this.$root.$on('cancel-align', this.cancelAlign)
      this.$root.$on('start-align', () => {
        this.alignProcess = true;
      })
      this.$root.$on('stop-align', () => {
        this.alignProcess = false;
      });

      this.$root.$on('from-audioeditor:visible', this.splitRecalc);

      /*this.$root.$on('for-audioeditor:load', this.resizeToc);
      this.$root.$on('for-audioeditor:load-and-play', this.resizeToc);
      this.$root.$on('from-audioeditor:close', this.resizeToc);
      this.$root.$on('from-audioeditor:content-loaded', this.resizeToc);*/
    },
    methods: {
      uploadAudio() {
        this.$modal.show(AudioImport, {
          book: this.currentBookMeta,
          uploadInfo: {}
        }, {
          height: 'auto',
          width: '590px',
          clickToClose: false
        });
      },
      renameAudiofile(id) {
        this.renaming = {
          id:id,
          titleOrigin: this.audiobook.importFiles.find(aif => aif.id == id).title
        };
      },

      audiobookValidate(value) {

        // linux
        // https://stackoverflow.com/questions/1976007/what-characters-are-forbidden-in-windows-and-linux-directory-names#:~:text=Under%20Linux%20and%20other%20Unix,path%20name%2C%20separating%20directory%20components.
        // windows
        // https://stackoverflow.com/questions/1976007/what-characters-are-forbidden-in-windows-and-linux-directory-names#:~:text=Under%20Linux%20and%20other%20Unix,path%20name%2C%20separating%20directory%20components.
        // https://stackoverflow.com/questions/265769/maximum-filename-length-in-ntfs-windows-xp-and-windows-vista

        let result = true;
        // Empty or only spaces
        result = value.replace(/\s+/g,'').length>0;

        // // linux characters
        // result = result && value.match(/[@\/]/,'') === null;
        //
        // // windows characters
        // result = result && value.match(/[<>:"\/\\\|\?\*]/,'') === null;
        //
        // // windows Filenames cannot end in a dot.
        // result = result && value.match(/(.?)*\.+/,'') === null;
        //
        // // windows Filenames cannot end in a space.
        // result = result && value.match(/(.?)*\s+/,'') === null;
        //
        // // macOS characters
        // result = result && value.match(/[:/]/,'') === null;
        //
        // // non ascii characters
        // result = result && value.match(/[^ -~]+/,'') === null;
        //
        // // length
        // result = result && value.length<=245;

        return result;
      },
      renameAudiofileStop() {
        this.renaming = false;
      },
      saveAudiobook(reorder = [], removeFiles = [], done = [], sortDirection = '') {
        if (removeFiles) {
          removeFiles.forEach(rf => {
            if (typeof this.positions_tmp[rf] !== 'undefined') {
              delete this.positions_tmp[rf];
            }
          })
        }
        let api_url = this.API_URL + 'books/' + this.audiobook.bookid + '/audiobooks/' + encodeURIComponent(this.audiobook.id);
        let formData = new FormData();
        //let save_data = this.audiobook;
        //if (save_data.importFiles) {
          //save_data.importFiles.forEach(af => {
            //if (typeof this.positions_tmp[af.id] !== 'undefined') {
              //af.positions = this.positions_tmp[af.id];
            //}
          //});
        //}
        //formData.append('audiobook', JSON.stringify(save_data));
        formData.append('reorder', JSON.stringify(reorder));
        formData.append('removeFiles', JSON.stringify(removeFiles));
        formData.append('sortDirection', sortDirection);
        let rename = [];
        if (this.renaming) {
          let renaming = this.audiobook.importFiles.find(aif => aif.id == this.renaming.id);
          if(!this.audiobookValidate(renaming.title)){
            renaming.title = this.renaming.titleOrigin;
            this.renameAudiofileStop();
            // this.renaming = false;
            return
          }
          if (renaming) {
            rename.push({
                id: renaming.id,
                title: renaming.title,
              });
          }
        }
        if (this.audiobook.importFiles) {
          this.audiobook.importFiles.forEach(af => {
            if (typeof this.positions_tmp[af.id] !== 'undefined') {
              rename.push({id: af.id, positions: this.positions_tmp[af.id]});
            }
          });
        }
        done.forEach(d => {
          rename.push(d);
        });
        formData.append('rename', JSON.stringify(rename));
        this.renameAudiofileStop();
        let api = this.$store.state.auth.getHttp()
        let self = this;
        return api.post(api_url, formData, {}).then(function(response){
          if (response.status===200) {
            if (response.data && response.data.audio) {
              self.getAudioBook();
            }
          } else {

          }
          return Promise.resolve();
        }).catch((err) => {
          console.log('error: '+ err)
          return Promise.reject();
        });
      },
      addSelection(id, value) {
        if (value === true) {
          if (this.selections.indexOf(id) === -1 && !this.isAudiofileAligning(id)) {
            this.selections.push(id)
          }
        } else {
          this.selections.splice(this.selections.indexOf(id), 1)
          $('input[name="' + id + '"]').prop('checked', false);
        }
        if (this.selections.length > 1 && this.playing) {
          this.$root.$emit('for-audioeditor:close');
        }
      },
      audiofileClick:_.debounce(function(id, play, event) {
        if (id === this.playing || this.isAudiofileAligning(id)) {
          return false;
        }
        if (!this.audioOpening && !event.shiftKey && !event.ctrlKey && !event.metaKey) {
          if (!this.renaming) {
            this.initSplit(true, true);
            this.audioOpening = id;
          }
        } else if (!event.shiftKey && !event.ctrlKey && !event.metaKey) {
          return;
        }
        let BreakException = {};
        if(!this.renaming && event) {
          if (event.shiftKey) {
            if (this.selections.length > 0) {
              if (this.selections.indexOf(id) === -1) {
                let select = false;
                this.addSelection(id, true);
                let clicked_passed = false;
                try {
                  this.audiobook.importFiles.forEach(af => {
                    if (!clicked_passed) {
                      clicked_passed = af.id === id;
                    }
                    if (this.selections.indexOf(af.id) !== -1) {
                      if (select === false || clicked_passed) {
                        select = !select;
                        if (select === false) {
                          throw BreakException;
                        }
                      }
                    }
                    if (select) {
                      this.addSelection(af.id, true)
                    }
                  });
                } catch (e) {
                  if (e !== BreakException) {
                    throw(e);
                  }
                }
              } else {
                let split = {before: [], after: []};
                let container = split.before;
                this.audiobook.importFiles.forEach(af => {
                  if (this.selections.indexOf(af.id) !== -1) {
                    if (af.id === id) {
                      container = split.after;
                    } else {
                      container.push(af.id);
                    }
                  }
                });
                this.selections = [];
                this.addSelection(id, true);
                if (split.before.length < split.after.length || split.before.length === split.after.length) {
                  split.before.forEach(_id => this.addSelection(_id, true));
                } else {
                  split.after.forEach(_id => this.addSelection(_id, true));
                }
              }
            } else {
              this.addSelection(id, true);
              this.play(id, play);
            }
          } else if(event.ctrlKey || event.metaKey) {
            if (this.selections.indexOf(id) === -1) {
              this.addSelection(id, true);
            } else {
              this.addSelection(id, false);
            }
          } else {
            this.selections = [id];
            this.play(id, play);
          }
        }
      }, 500),
      duplicateAudiofileClick(id, duplicate_id, event) {
        const el = this.$el.getElementsByClassName(duplicate_id.replace(/\./g, ''))[0];
          if (el) {
            this.highlightDuplicateId = duplicate_id.replace(/\./g, '');
            el.scrollIntoView();
          }
      },
      playPreview(id, preview) {
        if (!this.allowEditing) {
          return;
        }
        if (id === this.playing) {
          return;
        }
        if (id) {let record = this.audiobook.importFiles.find(f => {
            return f.id == id;
          })
          if (record && record.preview && record.preview[preview]) {
            if (!this.audio_element) {
              this.audio_element = document.createElement('audio')
            }
            this.audio_element.src = process.env.ILM_API + this.audiobook.importUrl + record.preview[preview];
            this.audio_element.play();
          }
        }
        this.paused = false;
      },
      checkAll(event, value) {
        if (event && event.target) {
          value = event.target.checked;
        }
        //$('.file-catalogue-files input[type="checkbox"]').prop('checked', value);
        if (this.audiobook.importFiles) {
          this.audiobook.importFiles.forEach(_f => {
            this.addSelection(_f.id, value)
          })
        }
      },
      deleteAudio(id) {
        this.onDeleteMessage = true;
        this.deleting = id;

      },
      deleteAudioProcess() {
        if (!this.deleting) {
          if (!this.selections.length) {
            return false;
          }
          //let files = [];
          //this.audiobook.importFiles.forEach((_f, i) => {
            //if (this.selections.indexOf(_f.id) === -1) {
              //files.push(_f);
            //} else {
              //this.addSelection(_f.id, false);
            //}
          //});
          //this.audiobook.importFiles = files;
          let toDelete = this.selections;
          this.selections = [];
          this.checkAllState = false;
          this.saveAudiobook([], toDelete);
        } else {
          let files = [];
          if (this.selections.indexOf(this.deleting) !== -1) {
            this.addSelection(this.deleting, false);
          }
          this.audiobook.importFiles.forEach((_f, i) => {
            if (_f.id !== this.deleting) {
              files.push(_f);
            }
          });
          this.audiobook.importFiles = files;
          this.saveAudiobook();
        }
        this.onDeleteMessage = false;
        let self = this;
        Vue.nextTick(() => {
          self.selections.forEach(s => {
            $('input[name="' + s + '"]').prop('checked', true);
          });
        })
      },
      discardDeleteAudio() {
        this.onDeleteMessage = false;
        this.deleting = false;
      },
      play(id, autostart) {
        if (!this.allowEditing) {
          return;
        }
        if (id === this.playing) {
          return;
        }
        if (id) {
          let reloadOnChange = this.playing != id
          let record = this.audiobook.importFiles.find(f => {
            return f.id == id;
          })
          if (record/* && this.player*/) {
            let audio_th = record['ver'] && record['ver']['m4a'] ? record['ver']['m4a'] : record.id
            this.$root.$emit('for-audioeditor:load-and-play', process.env.ILM_API + this.audiobook.importUrl + audio_th, '', null, autostart, record, reloadOnChange);
          }
        } else if (this.player) {
          this.player.play();
        }
        this.paused = false;
      },
      pause() {
        this.player.pause();
        this.paused = this.playing;
      },
      stop() {
        this.player.stop();
        this.paused = false;
        this.playing = false;
      },
      parseAudioLength(record) {
        if (!record.duration) {
          return '';
        }
        let l = record.duration.split(':');
        if (l.length === 3) {
          l.shift();
        }
        if (l[1]) {
          l[1] = l[1].split('.').shift();
        }
        let length = l.join(':');
        let selection = this.positions_tmp[record.id] ? this.positions_tmp[record.id] : {};
        if (record.positions && typeof record.positions.start !== 'undefined' && typeof selection.start === 'undefined') {
          selection = record.positions;
        }
        if (selection && typeof selection.start !== 'undefined' && typeof selection.end !== 'undefined') {
          let selected = '';
          let selectionLength = selection.end - selection.start;
          let selectionStart=parseInt(selectionLength / 60);
          if (selectionStart < 10) {
            selectionStart = '0' + selectionStart;
          }
          selected+=selectionStart;
          selected+=':';
          let selectionEnd=parseInt(selectionLength % 60);
          if (selectionEnd < 10) {
            selectionEnd = '0' + selectionEnd;
          }
          selected+=selectionEnd;
          if (selectionStart != l[0] || selectionEnd != l[1]) {
            length = selected + ' of ' + length;
          }
        }
        return length;
      },
      align(id = null, warn = 2) {
        if (warn >= 2 && this.currentBookCounters.approved_audio_in_range > 0) {
          this.$root.$emit('show-modal', {
            title: 'Are you sure you want to realign ' + this.currentBookCounters.approved_audio_in_range + ' approved block(s)?',
            //text: 'Are you sure you want to realign ' + this.currentBookCounters.approved_audio_in_range + ' approved block(s)?',
            text: '',
            buttons: [
              {
                title: 'Cancel',
                handler: () => {
                  this.$root.$emit('hide-modal');
                  //this.cancelAlign();
                },
              },
              {
                title: 'Realign',
                handler: () => {
                  this.$root.$emit('hide-modal');
                  let i = setInterval(() => {
                    if ($('.align-modal').length == 0) {
                      clearInterval(i);
                      this.align(id, 1)
                    }
                  }, 50);
                },
                'class': 'btn btn-primary'
              }
            ],
            class: ['align-modal']
          });
          return;
        }
        if (warn >= 1 && this.currentBookCounters.changed_in_range_audio > 0) {
          this.$root.$emit('prepare-alignment');
          this.callUnsavedChangesPopup('audio_file', this.align, [id, false]);
          return;
        }
        //this.alignmentProcess = true;
        let realign = this.currentJobInfo.mastering;
        let update = this.saveAudiobook()
          .then((updated) => Promise.resolve(updated))
          .catch((err) => Promise.resolve({error: true, err: err}));
        Promise.all([update])
          .then((updated) => {
            this.$root.$emit('start-align');
            this.$root.$emit('for-audioeditor:check-close-realigning-block', "audio_file");
            return this.alignBook({
              start: this.blockSelection.start._id,
              end: this.blockSelection.end._id,
              audiofiles: id ? [id] : this.selections,
              realign: realign,
              positions: this.positions_tmp
            })
            .then((response) => {
              this.$root.$emit('stop-align');
              this.selections = [];
              if (response.status===200) {
                //self.$root.$emit('bookBlocksUpdates', response.data);
                this.$emit('alignmentFinished');
                this.aligningBlocks = [];
              } else if (response.status == 504) {
                //self.checkAligningBlocks();
              }
            });
          });
      },
      callUnsavedChangesPopup(voicework, callback, callbackParams) {
        let callbackProps = {
          saved: false
        };
        this.$modal.show(UnsavedChangesPopup, {
            voicework: voicework,
            callbackProps: callbackProps
          },
          {
            height: 'auto',
            width: '400px',
            clickToClose: false
          },
          {
            'closed': () => {
              if (callbackProps.saved) {
                callback.call(this, ...callbackParams);
              }
            }
          }
        );
      },
      checkAligningBlocks() {
        this.$root.$off('blockChange');
        var dbPath = superlogin.getDbUrl('ilm_content');
        var db = new PouchDB(dbPath);
        let keys = [];
        this.aligningBlocks.forEach(b => keys.push(b._id));
        db.allDocs({keys: keys, include_docs: true})
          .then(docs => {
            //console.log(docs);
            if (docs.rows) {
              docs.rows.forEach(doc => {
                let d = this.aligningBlocks.find(b => b._id == doc.id);
                if (d && d._rev != doc.value.rev) {
                  this.$root.$emit('bookBlocksUpdates', {blocks: [doc.doc]});
                  let i = this.aligningBlocks.indexOf(d);
                  if (i !== -1) {
                    this.aligningBlocks.splice(i, 1);
                  }
                }
              })
              if (this.aligningBlocks.length > 0) {
                setTimeout(() => {
                  this.checkAligningBlocks();
                }, 5000);
              } else {
                this.$emit('alignmentFinished');
              }
            }
            this.setCurrentBookCounters();
          })
          .catch(err => {
            console.log(err);
          })
      },
      cancelAlign(force = false) {
        return this.cancelAlignment([this.currentBookid]);
      },
      alignTts(warn = 2) {
        if (warn >= 2 && this.currentBookCounters.approved_tts_in_range > 0) {
          this.$root.$emit('show-modal', {
            title: 'Are you sure you want to realign ' + this.currentBookCounters.approved_tts_in_range + ' approved block(s)?',
            //text: 'Are you sure you want to realign ' + this.currentBookCounters.approved_audio_in_range + ' approved block(s)?',
            text: '',
            buttons: [
              {
                title: 'Cancel',
                handler: () => {
                  this.$root.$emit('hide-modal');
                  //this.cancelAlign();
                },
              },
              {
                title: 'Realign',
                handler: () => {
                  this.$root.$emit('hide-modal');
                  let i = setInterval(() => {
                    if ($('.align-modal').length == 0) {
                      clearInterval(i);
                      this.alignTts(1)
                    }
                  }, 50);
                },
                'class': 'btn btn-primary'
              }
            ],
            class: ['align-modal']
          });
          return;
        }
        if (warn >= 1 && this.currentBookCounters.changed_in_range_tts > 0) {
          this.$root.$emit('prepare-alignment');
          this.callUnsavedChangesPopup('tts', this.alignTts, [false]);
          return;
        }
        return this.checkVoiceAvailable()
          .then(response => {
            return this.checkBlockTTSForPattern()
              .then(response => {
                if (this.alignTTSVoicesData.total.length > 1) {
                  this.$modal.show(AlignTTSVoice,
                    {},
                    {
                      height: 'auto',
                      width: '400px',
                      clickToClose: false
                    }
                  );
                } else {
                  this.$root.$emit('start-align');
                  this.$root.$emit('for-audioeditor:check-close-realigning-block', 'tts');
                  return this.alignTTS()
                    .then((response) => {
                    this.$root.$emit('stop-align');
                    if (response.status===200) {
                      //this.$root.$emit('bookBlocksUpdates', response.data);
                      this.$emit('alignmentFinished');
                      //this.aligningBlocks = [];
                    } else if (response.status == 504) {
                      //self.checkAligningBlocks();
                    }
                  }).catch((err) => {
                    this.$root.$emit('stop-align');
                  });
                }
              });
          })
          .catch(err=>{
            this.$root.$emit('show-modal', {
              title: 'Voice is not available',
              text: `“${this.getSelectedInitCharacter?.name}” voice is no longer available. Please select another voice`,
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    this.$root.$emit('hide-modal');
                    //this.cancelAlign();
                  },
                  class: 'btn btn-primary'
                }
              ],
              class: ['align-modal']
            });
          });
      },
      scrollToBlock(id) {
        this.$root.$emit('for-bookedit:scroll-to-block', id);
      },

      onTtsSelect(key, value) {
        this.currentBookMeta.voices[key] = value;
        if (value) this.$emit('onTtsSelect', 'voices.'+ key, value);
      },

      listReorder(info) {
        if (info && typeof info.newIndex !== 'undefined' && typeof info.oldIndex !== 'undefined' && info.newIndex !== info.oldIndex) {
          this.saveAudiobook([[info.oldIndex, info.newIndex]]);
        }
      },
      //field: 'name', 'date'; direction: 'asc', 'desc'
      listSort(field, direction){
        if (field == 'name'){
          if (direction == 'asc'){
            this.aad_sort = 'name_asc';
          }
          if (direction == 'desc'){
            this.aad_sort = 'name_desc';
          }
        }
        if (field == 'date'){
          if (direction == 'asc'){
            this.aad_sort = 'date_asc';
          }
          if (direction == 'desc'){
            this.aad_sort = 'date_desc';
          }
        }
        this.saveAudiobook([], [], [], this.aad_sort);
        this.$refs.allAudioDropdownSort.toggle();
      },
      filterAll() {
        this.aad_filter = 'all';
        this.$refs.allAudioDropdownFilter.toggle();
      },
      filterAligned() {
        this.aad_filter = 'aligned';
        this.$refs.allAudioDropdownFilter.toggle();
      },
      filterPending() {
        this.aad_filter = 'pending';
        this.$refs.allAudioDropdownFilter.toggle();
      },
      filterFileNameInput() {
        this.aad_filter = 'filename';
      },
      filterFileNameReset() {
        this.filterFilename = '';
        this.aad_filter = 'all';
      },
      filterFileName() {
        this.aad_filter = 'filename';
        this.$refs.allAudioDropdownFilter.toggle();
      },
      markSelected() {
        this._setDone(true);
        this.$refs.allAudioDropdownFilter.toggle();
      },
      unmarkSelected() {
        this._setDone(false);
        this.$refs.allAudioDropdownFilter.toggle();
      },
      mark(id) {
        this._setDone(true, [id]);
      },
      unmark(id) {
        this._setDone(false, [id]);
      },
      _setDone(done, ids = []) {
        if (!ids.length) {
          ids = this.selections;
        }
        if (ids.length) {
          let doneUpdates = [];
          ids.forEach(id => {
            this.audiobook.importFiles.forEach((f, i) => {
              if (f.id === id) {
                doneUpdates.push({id: id, done: done});
              }
            });
          });
          this.saveAudiobook([], [], doneUpdates);
        }
      },
      _setCatalogueSize( ) {
        //let file_catalogue_height = $(document).height();
        //$('.file-catalogue-files').css('max-height', `${file_catalogue_height}px`);
      },

      clearErrors() {
        let url = this.API_URL + 'books/' + this.currentBookid + '/audiobooks/' + this.audiobook._id + '/clear_errors';
        this.$store.state.auth.getHttp().post(url)
          .then(resp => {
            this.getAudiobook();
          })
          .catch(err => {
            console.log(err)
          })
      },
      inViewport($el) {
        var elH = $el.outerHeight(),
          H   = $(window).height(),
          r   = $el[0].getBoundingClientRect(), t=r.top, b=r.bottom;
        return Math.max(0, t>0? Math.min(elH, H-t) : Math.min(b, H));
      },
      splitRecalc(force = false, state) {
        let height = this.getFileCatalogueContainerHeight();
        if (height) {
          $('.file-catalogue-files-wrapper').css('max-height', height + 'px');
        }
        this.checkCatalogueScroll();

      },
      initSplit(force = false, state) {
        //console.log('initSplit')
        // if (force || (this.isActive === true && $('.gutter.gutter-vertical').length == 0 && $('#file-catalogue').length > 0 && this.activeTabIndex === 0)) {
        if (force || (this.isActive === true && $('#file-catalogue').length > 0 && this.activeTabIndex === 0)) {
          let parentHeight = false;
          let parentBottomPadding = false;
          let minSize = false;
          let maxSize = false;
          if(this.split){
            this.split.destroy();
          }
          let self = this;
          this.split = Split(['#file-catalogue', '#audio-import-errors'], {
            direction: 'vertical',
            gutterSize: 0,
            //minSize: [80, 80],
            sizes: [70, 30],
            elementStyle: (dimension, size, gutterSize) => {

              //console.log(`elementStyle`);

              let resizeWrapper = true;
              parentHeight = parseInt($(document).height());
              //console.log(`parentHeight:${parentHeight}`);
              if(state || $('.waveform-playlist:visible').length ){
                if( $('.annotations-boxes').length ){
                  parentBottomPadding = 435;
                }else{
                  parentBottomPadding = 410;
                }
                parentHeight -=20;
              }else{
                parentBottomPadding = 240;
              }
              parentHeight -=parentBottomPadding
              //console.log(`parentHeight:${parentHeight}`);

              if (!parentHeight) {
                parentHeight = parseInt($('#file-catalogue').parent().css('height'));
                resizeWrapper = false;
                if (parentHeight) {
                  minSize = parentHeight / 100 * 30;
                  $('#audio-import-errors').css('height', minSize + 'px');
                  maxSize = parentHeight - minSize;
                }
              }
              //console.log(dimension, size, gutterSize)
              //console.log(`waveform-playlist:${$('.waveform-playlist:visible').length}`);
              //console.log(`size:${size}`);
              //console.log(`gutterSize:${gutterSize}`);

              // The additional scroll is appear
              parentHeight -=45;
              //console.log(`parentHeight:${parentHeight}`);

              let height = parentHeight / 100 * size - gutterSize;


              //console.log('SET HEIGHT TO', height - gutterSize + 'px', height, parentHeight)
              if (resizeWrapper || force) {
                let containerHeight = this.getFileCatalogueContainerHeight();
                if (containerHeight) {
                  $('.file-catalogue-files-wrapper').css('max-height', containerHeight + 'px');
                }
                this.checkCatalogueScroll();
                // height = this.inViewport($('.file-catalogue-files-wrapper'));
                // console.log(`parentHeight inViewport:${parentHeight}`);
                //
                //
                // setTimeout( () => {
                //   // debugger;
                //   if(!state && !self.playing){
                //     height -= 80
                //   }else{
                //     height -= 65
                //   }
                //   height = this.inViewport($('.file-catalogue-files-wrapper'));
                //   console.log(`parentHeight inViewport:${parentHeight}`);
                //   $('.file-catalogue-files-wrapper').css('height', height + 'px')
                // }, 5000);
                // // _.debounce( ,500);

              }
              if (height < minSize && resizeWrapper) {
                height = minSize;
              }
              if (height > maxSize && resizeWrapper) {
                height = maxSize;
              }
              //console.log(`height:${height}`);
              return {'height': height + 'px'};
            }

          });
          //console.log(split)
        }
      },
      isAudiofileAligned(audiofile) {
        if ('done' in audiofile && audiofile.done == true){
          return true;
        } else {
          return false;
        }
      },

      capitalizeFirst(text) {
        return _.upperFirst(text);
      },

      goToBlock(id) {
        this.$emit('goToBlock', id);
      },

      checkCatalogueScroll() {
        Vue.nextTick(() => {
          if ($('.file-catalogue-files-wrapper').is(':visible')) {// check if additional scroll appears
            let scrollHeight = parseInt($('.sidebar')[0].scrollHeight) - parseInt($('.sidebar').height());
            if (scrollHeight > 0) {
              let heightDifference = parseInt($('.file-catalogue-files-wrapper').height() - (scrollHeight + 2));
              $('.file-catalogue-files-wrapper').css('max-height', `${heightDifference}px`);
            }
          }
        });
      },

      checkTabOpen(ev) {// on tab open event component start slowly open, need to wait until full open
        if (ev.index === 0) {
          let containerHeight = this.getFileCatalogueContainerHeight();
          if (containerHeight) {
            $('.file-catalogue-files-wrapper').css('max-height', `${containerHeight}px`);
          }
          /*let tab = document.querySelector(`.audio-integration-accordion .p-accordion-tab:nth-child(${ev.index + 1}) .p-toggleable-content`);
          if (tab) {
            let checks = 0;
            let prevHeight = null;
            let checkInterval = setInterval(() => {
              if (prevHeight !== null && prevHeight === tab.offsetHeight) {
                clearInterval(checkInterval);
                this.checkCatalogueScroll();
              } else {
                prevHeight = tab.offsetHeight;
              }
              ++checks;
              if (checks >= 20) {
                clearInterval(checkInterval);
              }
            }, 50);
          }*/
        }
      },

      getFileCatalogueContainerHeight() {
        let containerHeight = 0;
        let container = document.querySelector('.sidebar');// main container for all section
        if (container) {
          containerHeight = container.offsetHeight;
          let tabs = container.querySelector('.p-tabview-nav-content');// menu tabs
          if (tabs) {
            containerHeight-= tabs.offsetHeight;
          }
          let header = document.querySelector('.audio-integration-accordion .p-accordion-header');// headers in accordion
          if (header) {
            containerHeight-= header.offsetHeight * 3;
          }
          containerHeight-= 135;// height for file catalogue buttons
        }
        return containerHeight && containerHeight > 0 ? containerHeight : null;
      },

      isAudiofileAligning(fileId) {
        return this.aligningAudiofiles.includes(fileId);
      },

      getAudiofileClass(audiofile) {
        return ['audiofile', {
            '-selected': this.highlightedAudiofiles.includes(audiofile.id)
          },
          {
            '-renaming': (this.renaming && (this.renaming.id == audiofile.id && !audiofile.duplicate))
          },
          {
            '-hidden': ((this.isAudiofileAligned(audiofile) && this.aad_filter == 'pending') || (!this.isAudiofileAligned(audiofile) && this.aad_filter == 'aligned'))
          },
          {
            '-aligning': this.isAudiofileAligning(audiofile.id)
          }];
      },
      setHighlightedAudiofiles() {
        let highlightedAudiofiles = [];
        this.selectedBlocks.forEach(blockId => {
          const block = this.parlist.get(blockId);
          if (block.audiocatalog_map instanceof Object && Object.keys(block.audiocatalog_map).length > 0) {
            Object.keys(block.audiocatalog_map).forEach(file_id => {
              if (!highlightedAudiofiles.includes(file_id)) {
                highlightedAudiofiles.push(file_id);
              }
            });
          } else {
            let hasMap = this.audiobook.importFiles ? this.audiobook.importFiles.find(audiofile => {
              return audiofile.blockMap && typeof audiofile.blockMap[block.blockid] !== 'undefined';
            }) : false;

            if (hasMap) {
              highlightedAudiofiles.push(hasMap.id);
            }
          }
        });
        this.highlightedAudiofiles = highlightedAudiofiles;
      },

      ...mapActions(['setCurrentBookCounters', 'clearLocks', 'getBookAlign', 'getAudioBook','setAudioRenamingStatus']),
      ...mapActions('alignActions', ['alignBook', 'alignTTS', 'cancelAlignment', 'checkBlockTTSForPattern']),
      ...mapActions('ttsModule', ['checkVoiceAvailable']),
    },
    beforeDestroy() {
      this.$root.$off('from-audioeditor:save-positions');
      this.$root.$off('from-audioeditor:align');
      this.$root.$off('cancel-align', this.cancelAlign);
      this.$root.$off('from-audioeditor:visible', this.splitRecalc);
    },
    computed: {
      selectionLength: {
        get() {
          return this.selections.length
        }
      },
      checkAllState: {
        get() {
          return this.audiobook && this.audiobook.importFiles && this.audiobook.importFiles.length ? this.selections.length == this.audiobook.importFiles.length : false;
        },
        set(val) {
          this.checkAll(null, val)
        }
      },
      enableAlignment: function() {
        return this.hasBlocksForAlignment && this.selectionLength > 0
      },
      enableTtsAlignment: function() {
        let voicesSelected = true;
        if (this.currentBookMeta.voices) {
          for(let voice in this.currentBookMeta.voices) {
            if (!this.currentBookMeta.voices[voice] || this.currentBookMeta.voices[voice].length == 0) {
              voicesSelected = false;
            }
          }
        }
        //console.log('enableTtsAlignment', voicesSelected, this.currentBookMeta.voices);
        return this.hasBlocksForTTS && voicesSelected && this.blockSelection.start._id && this.blockSelection.end._id;
      },
      hasBlocksForAlignment: function() {
        return this.alignCounter.count > 0;
      },
      hasBlocksForTTS: function() {
        return this.alignCounter.countTTS > 0;
      },
      blocksForAlignment: function() {
        let blocks = this.alignCounter.count - this.alignCounter.countTTS;
        return blocks >=0 ? blocks : 0;
      },
      allowEditing: function() {
        return this._is('editor', true) || this.adminOrLibrarian;
      },
      startAlignDisabled: {
        get() {
          return this.alignCounter.countAudio == 0 || this.selections.length == 0 || !this.allowAlignBlocksLimit;
        }
      },
      ...mapGetters({
        currentBookCounters: 'currentBookCounters',
        currentBookid: 'currentBookid',
        currentBookMeta: 'currentBookMeta',
        blockSelection: 'blockSelection',
        alignCounter: 'alignCounter',
        hasLocks: 'hasLocks',
        lockedBlocks: 'lockedBlocks',
        audiobook: 'currentAudiobook',
        currentJobInfo: 'currentJobInfo',
        adminOrLibrarian: 'adminOrLibrarian',
        allowAlignBlocksLimit: 'allowAlignBlocksLimit',
        alignBlocksLimitMessage: 'alignBlocksLimitMessage',
        parlist: 'storeList',
        selectedBlocks: 'selectedBlocks'
      }),
      ...mapGetters('alignActions', ['aligningAudiofiles', 'alignTTSVoicesData', 'currentAlignCounter']),
      ...mapGetters('elevenLabsVoicesModule', ['getSelectedInitCharacter']),
    },
    watch: {
      'audiobook': {
        handler(val, oldVal) {
          if (val && oldVal && val._id && oldVal._id && val._id != oldVal._id) {
            //console.log('AUDIOBOOK CHANGED')
            //this.checkAllState = false;
            this.selections = [];
            this.playing = false;
            this.renaming = false;
            this.audioOpening = false;
            return;
          }
          //console.log('Audiobook changed');
          if (typeof val.importFiles !== 'undefined') {
            val.importFiles.forEach(_if => {
              if (typeof this.selections[_if.id] === 'undefined') {
                //this.selections[_if.id] = false;
              }
              this.selections.forEach((s, i) => {
                let exists = val.importFiles.find(v => {return v.id === s});
                if (!exists) {
                  delete this.selections[i];
                }
              });
            });
            let self = this;
            Vue.nextTick(() => {
              /*self.draggableList = new List(document.querySelector('.draggable-list'));
              self.draggableList.on('move', function (node, newIndex, prevIndex) {
                self.saveAudiobook([[prevIndex, newIndex]]);
              })*/
              self.selections.forEach(s => {
                $('input[name="' + s + '"]').prop('checked', true);
              });
            })
          }
        },
        deep: true
      },
      'alignmentProcess': {
        handler(val) {
          if (val) {
            this.$root.$emit('show-modal', {
              title: 'Aligning blocks ' + this.blockSelection.start._id + ' - ' + this.blockSelection.end._id + ' with audio',
              text: '<div class="align-preloader"></div>',
              buttons: [
                {
                  title: 'Cancel',
                  handler: () => {
                    this.$root.$emit('hide-modal');
                    this.cancelAlign();
                  },
                }
              ],
              class: ['align-modal']
            });
          } else {
            this.$root.$emit('hide-modal');
          }
        }
      },
      'onDeleteMessage': {
        handler(val) {
          if (val) {
            this.$root.$emit('show-modal', {
              title: this.deleting ? '<h4 class="modal-title">Delete audio file?</h4>' : '<h4 class="modal-title">Delete ' + this.selectionLength + ' audio files?</h4>',
              text: '',
              buttons: [
                {
                  title: 'Cancel',
                  handler: () => {
                    this.$root.$emit('hide-modal');
                    this.discardDeleteAudio();
                  }
                },
                {
                  title: 'Delete' + (!this.deleting ? '<span >(' + this.selectionLength + ')</span>' : ''),
                  handler: () => {
                    this.$root.$emit('hide-modal');
                    this.deleteAudioProcess();
                  }
                }
              ]
            });
          } else {
            this.$root.$emit('hide-modal');
          }

        }
      },
      'aligningBlocks': function() {
        /*if (this.aligningBlocks.length > 0) {
          this.alignmentProcess = true;
        } else {
          this.alignmentProcess = false;
        }*/
      },
      'blockSelection': {
        handler(val) {
          this.highlightDuplicateId = '';
          var openAudio = this.activeTabIndex == 0;
          var openTTS = this.activeTabIndex == 1;
          if (!openAudio && openTTS) {
            this.$root.$emit('from-bookedit:set-voice-test', this.blockSelection.start, this.blockSelection.end)
          }
          this.setHighlightedAudiofiles();
        },
        deep: true
      },
      'isActive': {
        handler(val) {
          this.initSplit();
          this.checkCatalogueScroll();
        }
      },
      'activeTabIndex': {
        handler(val) {
          //this.initSplit();
          setTimeout(() => {
            this.checkCatalogueScroll();
          }, 600);// tab activation time 50ms
        }
      },
      'renaming': {
        handler(val) {
          this.setAudioRenamingStatus(val);
          if (val !== false) {
            var i = setInterval(() => {
              if ($('#rename-input').length > 0) {
                $('#rename-input').focus();
                clearInterval(i);
              }
            }, 100)
          }
        }
      },
      "currentBookid": {
        handler(val) {
          this.selections = [];
          this.playing = false;
          this.renaming = false;
          this.audioOpening = false;
        }
      }
    }
  }
</script>
<style lang="less">

  .p-accordion.audio-integration-accordion {
    .p-accordion-content {
      /*padding-bottom: 0px;*/

      .volume-slider-margin {
        margin: 0px 8px;
      }
    }
    .block-selection-info {
      padding: 7px 20px 10px;
      a {
        cursor: pointer;
      }
    }
  }

  .btn-small {
    font-size: 12px;
  }
  .file-catalogue {
    .file-catalogue-buttons {
      padding-bottom: 10px;
    }
  }
  .file-catalogue {
    .file-catalogue-buttons {
      &>div {
        display: inline-block;
        text-align: center;
        &.delete-audio {
          i, span {
            color: red;
          }
        }
      }
      .btn {height: 34px;}
    }
    .file-catalogue-files-wrapper {
        height: 100%;
        overflow-y: scroll;
    }
    .file-catalogue-files-wrapper::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      border-radius: 10px;
      background-color: #F5F5F5;
    }
    .file-catalogue-files-wrapper::-webkit-scrollbar {
      width: 12px;
      background-color: #F5F5F5;
    }
    .file-catalogue-files-wrapper::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
      background-color: #555;
    }
    .file-catalogue-files {
      list-style-type: none;
      margin-left: 0px;
      padding-left: 0px;
      /*min-height: 300px;*/
      .audiofile {
        list-style-type: none;
        padding: 2px;
        display: flex;
        justify-content: space-between;

        &.-selected {
            background-color: #d0e9ff;
        }
        i.fa {
          display: inline-block;
          padding: 0px 2px;
          &.red {
              color: red;
          }
        }
        &.-hidden {
            display: none;
        }
        span {
          display: inline-block;
          /*padding: 0px 2px;*/
          display: inline-block;
          width: 100%;

          &.checkmark {
            top: 2px;
            left: 0;
          }
        }
        .audiofile-info {
          display: inline-block;
          width: 95%;
          white-space: nowrap;
          /*max-width: 80%;*/
          overflow: hidden;
          .audiofile-player-controls {
            width: 19px;
            display: inline-block;
          }
          .audiofile-name {
            display: inline-block;
            cursor: pointer;
            white-space: nowrap;
            max-width: 60%;
            overflow: hidden;
            vertical-align: sub;
            min-width: 60%;
            color: #323130;
            .filename {
              padding: 0px;
            }
          }
          .audiofile-duration {
            display: inline-block;
            overflow: hidden;
            vertical-align: sub;
            color: #323130;
          }
          .audiofile-name-edit {
            img {
              padding: 0px 3px 0px 0px;
              vertical-align: text-bottom;
            }
          }
          /*&.playing {
            color: maroon;
            i.fa {
              color: maroon;
            }
          }*/
          &.done {
            .audiofile-name .filename, .audiofile-duration {
              opacity: 0.5;
            }
          }
        }
        .audiofile-options {
          display: inline-block;
          vertical-align: super;
          width: 3%;
          .btn-group {
            .dropdown-toggle {
                padding: 6px;
            }
          }
          ul.dropdown-menu {
              margin-left: -56px;
              min-width: 97px;
              max-width: 97px;
          }
          .checkbox-container {
            display: flex;
            padding-top: 0px;
          }
        }
        button {
          background-color: inherit;
          border: none;
          cursor: pointer;
          span {
              display: none;
          }
        }
        ul.dropdown-menu {
          i {
              font-size: 12px;
              &.fa-trash {
                  color: red;
              }
              &.fa-check {
                  color: green;
              }
          }
          li {
              font-size: 12px;
              a {
                  display: inline-block;
                  padding: 0px 1px;
              }
          }
        }
        input[type="text"] {

        }
        input[disabled] {
            background-color: inherit;
            border: none;
        }
        &.-aligning {
          .audiofile-name {
            .filename {
              opacity: 0.5;
            }
          }
          .audiofile-duration {
            opacity: 0.5;
          }
          .checkbox-container {
            .checkmark {
              background-color: #BFBCBD;
              opacity: 0.5;
              &:after {
                display: block;
              }
            }
          }
        }
      }
    }
    .all-audio-dropdown {
      margin: 0px 10px;
      ul {
        span {
          display: inline-block;
          width: 100%;
          padding: 2px 12px;
          cursor: pointer;
          &.mark-done {
            color: gray;
          }
        }
      }
      span.caret {
        margin-top: -5px;
      }
    }
    .aad-sort button{
      font-family: 'Glyphicons Halflings';
    }
    .aad-sort button:before {
      content: "\e151";
      margin-right: -10px;
    }
    .aad-filter > button{
      font-family: 'Glyphicons Halflings';
    }
    .aad-filter > button:before {
      content: "\e138";
      margin-right: -10px;
    }
    .aad_selected {
     background: #95BCF2;
    }
    .left-divider {
      border-left: 1px solid #ccc;
      margin-left: 3px;
      padding-left: 7px;
    }
    .align-blocks-limit {
      padding: 0px 0px 0px 20px;
    }
    .red-message {
      color: red;
    }
  }
  h4.panel-title {
    font-size: 14px;
  }
  #player {
      display: none;
  }
  .red {
    color: red;
  }
  .align-preloader {
      background: url(/static/preloader-snake-small.gif);
      width: 100%;
      height: 34px;
      display: inline-block;
      margin: 4px 0px;
      background-repeat: no-repeat;
      background-position-x: center;
  }
  .align-modal {
    .modal-header {
        border-bottom: none;
    }
    .modal-body {
        text-align: center;
    }
    .modal-footer {
      button {
          width: 100%;
      }
    }
  }
  .panel-audio-catalogue {
      .p-accordion-content {
        padding-left: 9px;
        padding-right: 9px;
        .all-audio-dropdown {
            margin: 0px;
        }
      }
  }
  .audio-import-errors {
    border: solid 1px red;
    border-radius: 8px;
    padding: 8px 5px 5px 5px;
    background-color: #ffd3d3;
    margin-top: 10px;
    height: 95px;
    color: red;
    /*overflow-y: scroll;*/
    &.errors-0 {
      display: none;
    }
    .audio-import-error {
      padding: 2px;
      /*width: 80%;*/
      word-break: break-all;
      a {
        font-weight: bolder;
      }
      &:nth-child(even) {
        background-color: #fcebeb;
      }
    }
    .hide-errors {
      display: inline-block;
      float: right;
      cursor: pointer;
      padding: 0px 3px;
      color: black;
    }
  }
  .align-preloader {
      background: url(/static/preloader-horizontal.gif);
      display: inline-block;
      background-repeat: no-repeat;
      vertical-align: middle;
      background-position: center;
      &.-small {
        background-size: 70px auto;
        width: 70px;
      }
      &.-big {
          background-size: 100px auto;
          width: 100px;
      }
  }
  .audio-opening {
    background: url(/static/preloader-snake-transparent-tiny.gif);
    display: inline-block;
    width: 19px;
    height: 19px;
    background-size: 19px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .checkbox-container {
    display: block;
    position: relative;
    padding-left: 15px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    margin-left: -15px;
  }

  .checkmark {
    position: absolute;
    top: -3px;
    left: -2px;
    height: 15px;
    width: 15px;
    background-color: #eee;
    border: 1px solid #b3b0b0;
    border-radius: 3px;
  }

  .checkbox-container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  .checkbox-container input:checked ~ .checkmark {
    background-color: #317bb8;
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }

  .checkbox-container .checkmark:after {
    left: 5px;
    top: 1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .flexContainer {
      display: flex;
  }

  .inputField {
      flex: 1;
  }
  .btn_audio_upload {
    background-image: url("/static/import-audio-23.png");
    background-repeat: no-repeat;
    background-position: center;
    width: 43px;
  }

  .audiofile.-renaming .audiofile-options,.audiofile.-renaming .audiofile-player-controls{
    display: none !important;
  }

  .audiofile.-renaming .audiofile-name{
    width: 100% !important;
    max-width: 100% !important;
  }
  .audiofile.-renaming #rename-input{
    width: 90% !important;
  }

  .align-process-start {
    width: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/components/books/BookAudioIntegration.vue